lmApp
  .controller('ReportsController', ['$scope', '$rootScope', '$q', '$timeout', '$templateCache', '$compile', 'StatisticsService', 'ToastService', 'MetadataService', 'ModalWindowService', 'AssetResource',
    function ($scope, $rootScope, $q, $timeout, $templateCache, $compile, StatisticsService, ToastService, MetadataService, ModalWindowService, AssetResource) {

      var PseudeRandomColor = [
        '#f44336',
        '#e91e63',
        '#9c27b0',
        '#673ab7',
        '#3f51b5',
        '#2196f3',
        '#03a9f4',
        '#00bcd4',
        '#009688',
        '#4caf50',
        '#8bc34a',
        '#cddc39',
        '#ffeb3b',
        '#ffc107',
        '#ff9800',
        '#ff5722',
        '#795548',
        '#ff8a80',
        '#ff80ab',
        '#ea80fc',
        '#b388ff',
        '#8c9eff',
        '#82b1ff',
        '#b388ff',
        '#8c9eff',
        '#82b1ff',
        '#80d8ff',
        '#84ffff',
        '#a7ffeb',
        '#b9f6ca',
        '#ccff90',
        '#f4ff81'
      ];

      $scope.getPseudoRandomColor = function (a, index) {

        //return PseudeRandomColor[index - PseudeRandomColor.length * Math.floor(index / PseudeRandomColor.length)];
        return PseudeRandomColor[_.random(0, PseudeRandomColor.length)];
      };

      $scope.reportsData = {};
      $scope.reportsList = {};
      $scope.loading = false;
      $scope.statistic = {};
      $scope.currentReportType = null;

      $scope.totalVOD = {
          totalMovies: -1,
          totalActiveMovies: -1,
          totalSeries: -1,
          totalActiveSeries: -1,
          totalEpisodes: -1
      };

      Chart.pluginService.register({
        beforeDraw: function (chartInst) {
          var type = chartInst.config.options.report;
          var ctx;
          var controller;

          if (type === 'active-subscriber-stat') {
            ctx = chartInst.chart.ctx;
            controller = chartInst.chart.controller;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            chartInst.data.datasets.forEach(function (dataset, index) {
              if (index !== 1) return;

              for (var i = 0; i < dataset.data.length; i++) {

                if (dataset.data[i]) {
                  var model = controller.getDatasetMeta(index).data[i]._model;

                  ctx.font = "bold 15px Courier";
                  ctx.fillStyle = "#212121";
                  ctx.fillText(
                    _calculateValueOnTop(type, i),
                    model.x,
                    model.y - 10);
                }
              }
            });
          } else if (type === 'devices-total-bars') {
            ctx = chartInst.chart.ctx;
            controller = chartInst.chart.controller;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            chartInst.data.datasets.forEach(function (dataset, index) {
              for (var i = 0; i < dataset.data.length; i++) {

                if (dataset.data[i]) {
                  var model = controller.getDatasetMeta(index).data[i]._model;

                  ctx.font = "bold 15px Courier";
                  ctx.fillStyle = "#212121";
                  ctx.fillText(
                    dataset.data[i],
                    model.x,
                    model.y - 10);
                }
              }
            });
          }
        },
        afterDraw: function (chartInst) {
          var type = chartInst.config.options.report;
          var ctx;
          var controller;

          if (type === 'devices-total-pie1') {
            ctx = chartInst.chart.ctx;
            controller = chartInst.chart.controller;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';

            var labelxy = [];
            var lastend = 0;
            var offset = Math.PI / 2;

            chartInst.data.datasets.forEach(function (dataset, index) {
              for (var i = 0; i < dataset.data.length; i++) {

                if (dataset.data[i]) {
                  var model = controller.getDatasetMeta(index).data[i]._model;
                  var radius = model.outerRadius - model.innerRadius;
                  var centerx = model.x;
                  var centery = model.y + 10;

                  var total = _.sum(dataset.data);
                  var thispart = dataset.data[i];

                  var arcsector = Math.PI * (2 * thispart / total);

                  var lradius = radius * 1.5;

                  var langle = lastend + arcsector / 2 + Math.PI + offset;

                  var dx = centerx + lradius * Math.cos(langle);
                  var dy = centery + lradius * Math.sin(langle);

                  ctx.font = "bold 15px Courier";
                  ctx.fillStyle = "#fff";
                  ctx.fillText(
                    dataset.data[i],
                    dx,
                    dy);

                  lastend += arcsector;
                }
              }
            });
          }
        }
      });

      var _calculateValueOnTop = function (type, i) {
        if (type === 'active-subscriber-stat') {
          return $scope.statistic[type].data[0][i] + $scope.statistic[type].data[1][i] + $scope.statistic[type].data[2][i] + '(' + ($scope.statistic[type].data[1][i] + $scope.statistic[type].data[2][i]) + ')';
        }

        return '';
      };

      var _clearObject = function (object, ignore) {
        if (!ignore) ignore = [];

        for (var property in object) {
          if (object.hasOwnProperty(property)) {
            if (typeof object[property] == "object") {
              if (ignore.indexOf(property) === -1) {
                _clearObject(object[property]);
              } else {
                object[property] = {}
              }
            } else {
              object[property] = 0;
            }
          }
        }
      };

      var _spreadData = function (collection, calendar, opt) {
        if (!opt) opt = {};

        var statisticItem = _.cloneDeep(collection[0]);

        _clearObject(statisticItem, opt.ignore);

        return calendar.map(function (period) {
          var data = _.find(collection, function (o) {
            return period.isSame(o._date, 'month');
          });

          if (!data) data = {};
          data._date = period;

          return _.merge(_.cloneDeep(statisticItem), data);
        });
      };

      $scope.getFormattedDate = function (date, format) {

        return date ? date.format(format) : '';
      };

      $scope.getReportsList = function () {
        $scope.loading = true;
        $rootScope.showLinearProgress('#reportsLoader');

        StatisticsService.GetReportsList()
          .then(function (list) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#reportsLoader');
            $scope.reportsList = list.map(function (report) {
              report.startFrom = moment.utc();

              return report;
            });
          });
      };

      $scope.prevPeriod = function (report) {
        report.startFrom = $scope.statistic[report.type].calendar[0];

        $scope.generateReport(report);
      };

      $scope.nextPeriod = function (report) {
        report.startFrom = _.last($scope.statistic[report.type].calendar).clone().add(5, 'month');

        $scope.generateReport(report);
      };

      $scope.generateReport = function (report) {

        var opt;
        var parsedData;
        $scope.loading = true;
        $rootScope.showLinearProgress('#reportsLoader');
        $scope.currentReportType = report.type;

        $scope.statistic[report.type] = {};
        $scope.statistic[report.type].calendar = [];

        for (var i = -5; i < 1; i++) {
          $scope.statistic[report.type].calendar.push(report.startFrom.clone().add(i, 'month').startOf('month'));
        }

        switch (report.type) {
          //deprecate
          case 'subs-total':

            opt = {
              start: $scope.statistic[report.type].calendar[0].unix(),
              end: $scope.statistic[report.type].calendar[$scope.statistic[report.type].calendar.length - 1].clone().add(1, 'month').unix()
            };

            StatisticsService.GetSubscriberStat(opt)
              .then(function (collection) {

                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');

                if (!collection.length) {
                  ToastService.Small({
                    title: 'No data for this period',
                    color: 'yellow',
                    icon: 'chart-line',
                    blocked: true
                  }, 1000 * 5);

                  return;
                }

                collection = collection.map(function (item) {
                  item._date = moment.unix(item.date);

                  return item;
                });

                var parsedData = _spreadData(
                  collection,
                  $scope.statistic[report.type].calendar
                );

                $scope.statistic[report.type].collection = parsedData;

                $scope.statistic[report.type].labels = _.map(parsedData, function (item) {

                  return item._date.format('MMMM YYYY');
                });

                $scope.statistic[report.type].data = [
                  parsedData.map(function (value) {

                    return value.total - value.new;
                  }),
                  _.map(parsedData, 'new')
                ];

                $scope.statistic[report.type].colors = ['#2196f3', '#4caf50'];

                $scope.statistic[report.type].series = ['Total', 'New'];

                var maxed = _.maxBy(parsedData, function (o) {
                  return o.total;
                });

                $scope.statistic[report.type].options = {
                  responsive: true,
                  legend: {
                    display: true,
                    position: 'right'
                  },
                  scales: {
                    xAxes: [{
                      stacked: true
                    }],
                    yAxes: [{
                      stacked: true,
                      ticks: {
                        suggestedMax: (maxed) ? maxed.total + 20 : 100
                      }
                    }]
                  },
                  report: report.type
                };

              });
            break;


          case 'active-subscriber-stat':

            opt = {
              start: $scope.statistic[report.type].calendar[0].unix(),
              end: $scope.statistic[report.type].calendar[$scope.statistic[report.type].calendar.length - 1].clone().add(1, 'month').unix()
            };

            StatisticsService.GetActiveSubscriberStat(opt)
              .then(function (collection) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');

                if (!collection.length) {
                  ToastService.Small({
                    title: 'No data for this period',
                    color: 'yellow',
                    icon: 'chart-line',
                    blocked: true
                  }, 1000 * 5);

                  return;
                }

                collection = collection.map(function (item) {
                  item._date = moment.unix(item.date);

                  return item;
                });

                var parsedData = _spreadData(
                  collection,
                  $scope.statistic[report.type].calendar
                );

                $scope.statistic[report.type].collection = parsedData;

                $scope.statistic[report.type].labels = _.map(parsedData, function (item) {

                  return item._date.format('MMMM YYYY');
                });

                $scope.statistic[report.type].data = [
                  _.map(parsedData, 'total_on_beginning_of_month'),
                  _.map(parsedData, 'joined'),
                  _.map(parsedData, 'unsubscribed').map(function (value) {

                    return -(value);
                  })
                ];

                $scope.statistic[report.type].colors = ['#2196f3', '#4caf50', '#f44336'];

                $scope.statistic[report.type].series = ['Total On Beginning Of Month', 'Joined', 'Unsubscribed'];

                var maxed = _.maxBy(parsedData, function (o) {
                  return o.total_on_beginning_of_month + o.joined;
                });
                $scope.statistic[report.type].options = {
                  responsive: true,
                  legend: {
                    display: true,
                    position: 'right'
                  },
                  scales: {
                    xAxes: [{
                      stacked: true
                    }],
                    yAxes: [{
                      stacked: true,
                      ticks: {
                        suggestedMax: (maxed) ? maxed.total_on_beginning_of_month + maxed.joined + 20 : 100
                      }
                    }]
                  },
                  report: report.type
                };

              });

            break;

          case 'devices-total':
            opt = {
              start: $scope.statistic[report.type].calendar[0].unix(),
              end: $scope.statistic[report.type].calendar[$scope.statistic[report.type].calendar.length - 1].clone().add(1, 'month').unix()
            };

            StatisticsService.GetDeviceStat(opt)
              .then(function (collection) {

                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');

                if (!collection.length) {
                  ToastService.Small({
                    title: 'No data for this period',
                    color: 'yellow',
                    icon: 'chart-line',
                    blocked: true
                  }, 1000 * 5);

                  return;
                }

                //Distribution of devices monthly
                $scope.statistic[report.type].devices = {};

                $scope.statistic[report.type].devices.collection = [];

                collection = collection.map(function (item) {
                  item._date = moment.unix(item.date);

                  return item;
                });

                var devices = _.keys(collection[0].devices);

                parsedData = _spreadData(
                  collection,
                  $scope.statistic[report.type].calendar
                );

                $scope.statistic[report.type].devices.collection = parsedData;

                $scope.statistic[report.type].devices.labels = _.map(parsedData, function (item) {

                  return item._date.format('MMMM YYYY');
                });

                $scope.statistic[report.type].devices.data = [];
                devices.forEach(function (device) {

                  $scope.statistic[report.type].devices.data.push(
                    _.map(parsedData, 'devices.' + device + '.total')
                  );
                });

                $scope.statistic[report.type].devices.colors = devices.map(function (device) {

                  return MetadataService.GetPlatformColor({extid: device});
                });

                $scope.statistic[report.type].devices.series = devices.map(function (device) {

                  return MetadataService.GetPlatformName({extid: device});
                });

                var maxed = _.max(_.flatten($scope.statistic[report.type].devices.data));
                $scope.statistic[report.type].devices.options = {
                  responsive: true,
                  legend: {
                    display: true,
                    position: 'right'
                  },
                  scales: {
                    yAxes: [{
                      ticks: {
                        suggestedMax: (maxed) ? maxed + 20 : 100
                      }
                    }]
                  },
                  report: report.type + '-bars'
                };

                $scope.statistic[report.type].total = {};
                $scope.statistic[report.type].total.selectPeriod = function (index) {
                  $scope.statistic[report.type].total.period = $scope.statistic[report.type].devices.collection[index]._date;
                  $scope.statistic[report.type].total.data = _.map($scope.statistic[report.type].devices.collection[index].devices, 'total');
                };

                $scope.statistic[report.type].total.selectPeriod($scope.statistic[report.type].devices.collection.length - 1);

                $scope.statistic[report.type].total.labels = devices.map(function (device) {
                  return MetadataService.GetPlatformName({extid: device});
                });
                $scope.statistic[report.type].total.colors = devices.map(function (device) {

                  return MetadataService.GetPlatformColor({extid: device});
                });

                $scope.statistic[report.type].total.options = {
                  responsive: true,
                  legend: {
                    display: true,
                    position: 'right',
                    labels: {
                      generateLabels: function (chartInst) {

                        return chartInst.data.datasets[0].data.map(function (dataset, i) {
                          return {
                            text: $scope.statistic[report.type].total.labels[i] + ': ' + dataset,
                            fillStyle: chartInst.data.datasets[0].backgroundColor[i],
                            hidden: false
                          };
                        });
                      }
                    }
                  },
                  tooltips: {
                    enabled: true
                  },
                  report: report.type + '-pie'
                };

              });
            break;

          case 'packages-purchases':
            opt = {
              start: $scope.statistic[report.type].calendar[0].unix(),
              end: $scope.statistic[report.type].calendar[$scope.statistic[report.type].calendar.length - 1].clone().add(1, 'month').unix()
            };

            StatisticsService.GetPackagesUsage(opt)
              .then(function (collection) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');

                if (!collection.length) {
                  ToastService.Small({
                    title: 'No data for this period',
                    color: 'yellow',
                    icon: 'chart-line',
                    blocked: true
                  }, 1000 * 5);

                  return;
                }

                $scope.statistic[report.type].packages = {};
                $scope.statistic[report.type].packages.collection = [];

                $scope.statistic[report.type].packages.allPackages = _.map(_.values(_.keyBy(collection, 'package.id')), 'package');

                collection = _.values(_.mapValues(_.keyBy(collection, 'date'), function (o, key) {
                  return {
                    date: key,
                    packages: _.keyBy(collection, 'package.id')
                  };

                }));

                collection.forEach(function (item) {

                  item._date = moment.unix(item.date);
                });

                parsedData = _spreadData(
                  collection,
                  $scope.statistic[report.type].calendar,
                  {ignore: ['packages']}
                );

                $scope.statistic[report.type].packages.collection = parsedData;

                $scope.statistic[report.type].total = {};
                $scope.statistic[report.type].total.selectPeriod = function (index) {
                  $scope.statistic[report.type].total.period = $scope.statistic[report.type].packages.collection[index]._date;
                  $scope.statistic[report.type].total.data = _.map($scope.statistic[report.type].packages.collection[index].packages, 'usage_count');

                  $scope.statistic[report.type].total.labels = _.values($scope.statistic[report.type].packages.collection[index].packages).map(function (pckg) {
                    return pckg.package.title;
                  });

                  $scope.statistic[report.type].total.colors = _.values($scope.statistic[report.type].packages.collection[index].packages).map($scope.getPseudoRandomColor);
                };

                $scope.statistic[report.type].total.selectPeriod($scope.statistic[report.type].packages.collection.length - 1);

                $scope.statistic[report.type].total.options = {
                  responsive: true,
                  legend: {
                    display: true,
                    position: 'right'
                  },
                  tooltips: {
                    enabled: true
                  },
                  report: report.type + '-pie'
                };
              })
              .catch(function (reason) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');
                $rootScope.debugInfo(reason);
              });
            break;

          case 'content-usage':
            opt = {
              start: $scope.statistic[report.type].calendar[0].unix(),
              end: $scope.statistic[report.type].calendar[$scope.statistic[report.type].calendar.length - 1].clone().add(1, 'month').unix()
            };

            StatisticsService.GetTopContent()
              .then(function (collection) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');

                if (!collection.length) {
                  ToastService.Small({
                    title: 'No data for this period',
                    color: 'yellow',
                    icon: 'chart-line',
                    blocked: true
                  }, 1000 * 5);

                  return;
                }

                $scope.statistic[report.type].vodTop = _.last(collection).top.movie;
                $scope.statistic[report.type].liveTop = _.last(collection).top.channel;
              })
              .catch(function (reason) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');
                $rootScope.debugInfo(reason);
              });
            break;

          case 'total-vod':
            opt = {
              start: $scope.statistic[report.type].calendar[0].unix(),
              end: $scope.statistic[report.type].calendar[$scope.statistic[report.type].calendar.length - 1].clone().add(1, 'month').unix(),
              type: 'movie'
            };

            AssetResource.count({'type[eq]': 'movie'}).$promise
              .then(function (response) {
                $scope.totalVOD.totalMovies = response.data ? response.data : 0;
              })
              .catch(function (reason) {
                $scope.totalVOD.totalMovies = 0;
                $rootScope.debugInfo(reason);
              });

            AssetResource.count({'type[eq]': 'movie', 'status[eq]': 'active'}).$promise
              .then(function (response) {
                $scope.totalVOD.totalActiveMovies = response.data ? response.data : 0;
              })
              .catch(function (reason) {
                $scope.totalVOD.totalActiveMovies = 0;
                $rootScope.debugInfo(reason);
              });

            AssetResource.count({'type[eq]': 'series'}).$promise
              .then(function (response) {
                $scope.totalVOD.totalSeries = response.data ? response.data : 0;
              })
              .catch(function (reason) {
                $scope.totalVOD.totalSeries = 0;
                $rootScope.debugInfo(reason);
              });

            AssetResource.count({'type[eq]': 'series', 'status[eq]': 'active'}).$promise
              .then(function (response) {
                $scope.totalVOD.totalActiveSeries = response.data ? response.data : 0;
              })
              .catch(function (reason) {
                $scope.totalVOD.totalActiveSeries = 0;
                $rootScope.debugInfo(reason);
              });

            AssetResource.count({'type[eq]': 'episode'}).$promise
              .then(function (response) {
                $scope.totalVOD.totalEpisodes = response.data ? response.data : 0;
              })
              .catch(function (reason) {
                $scope.totalVOD.totalEpisodes = 0;
                $rootScope.debugInfo(reason);
              });

            StatisticsService.ActiveAssetStat(opt)
              .then(function (collection) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');

                if (!collection.length) {
                  ToastService.Small({
                    title: 'No data for this period',
                    color: 'yellow',
                    icon: 'chart-line',
                    blocked: true
                  }, 1000 * 5);

                  return;
                }

                $scope.statistic[report.type].collection = [];

                collection = collection.map(function (item) {
                  item._date = moment.unix(item.date);

                  return item;
                });

                parsedData = _spreadData(
                  collection,
                  $scope.statistic[report.type].calendar
                );

                $scope.statistic[report.type].collection = parsedData;

                $scope.statistic[report.type].showDetails = function (period, type) {

                  switch (type) {
                    case 'active_total':
                      $scope.statistic[report.type].details = {
                        data: period.active_details,
                        title: 'Active'
                      };

                      break;

                    case 'inactive':
                      $scope.statistic[report.type].details = {
                        data: period.inactive_details,
                        title: 'Inactive'
                      };

                      break;

                    case 'new':
                      $scope.statistic[report.type].details = {
                        data: period.new_details,
                        title: 'New'
                      };

                      break;

                    default:
                      $scope.statistic[report.type].details = {
                        data: [],
                        title: type
                      };

                      break;
                  }


                  var window = ModalWindowService.Open({
                    content: $compile($templateCache.get('statistics/reports/total-vod-details.html'))($scope),
                    keyboard: true,
                    isFixed: true,
                    actions: [
                      {
                        title: 'Close',
                        color: 'lm',
                        fn: function () {
                        }
                      }
                    ]
                  });
                };
              })
              .catch(function (reason) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');
                $rootScope.debugInfo(reason);
              });

            break;

          case 'total-live':
            opt = {
              start: $scope.statistic[report.type].calendar[0].unix(),
              end: $scope.statistic[report.type].calendar[$scope.statistic[report.type].calendar.length - 1].clone().add(1, 'month').unix(),
              type: 'channel'
            };

            StatisticsService.ActiveAssetStat(opt)
              .then(function (collection) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');

                if (!collection.length) {
                  ToastService.Small({
                    title: 'No data for this period',
                    color: 'yellow',
                    icon: 'chart-line',
                    blocked: true
                  }, 1000 * 5);

                  return;
                }

                $scope.statistic[report.type].collection = [];

                collection = collection.map(function (item) {
                  item._date = moment.unix(item.date);

                  return item;
                });

                parsedData = _spreadData(
                  collection,
                  $scope.statistic[report.type].calendar
                );

                $scope.statistic[report.type].collection = parsedData;

                $scope.statistic[report.type].showDetails = function (period, type) {

                  switch (type) {
                    case 'active_total':
                      $scope.statistic[report.type].details = {
                        data: period.active_details,
                        title: 'Active'
                      };

                      break;

                    case 'inactive':
                      $scope.statistic[report.type].details = {
                        data: period.inactive_details,
                        title: 'Inactive'
                      };

                      break;

                    case 'new':
                      $scope.statistic[report.type].details = {
                        data: period.new_details,
                        title: 'New'
                      };

                      break;

                    default:
                      $scope.statistic[report.type].details = {
                        data: [],
                        title: type
                      };

                      break;
                  }


                  var window = ModalWindowService.Open({
                    content: $compile($templateCache.get('statistics/reports/total-live-details.html'))($scope),
                    keyboard: true,
                    isFixed: true,
                    actions: [
                      {
                        title: 'Close',
                        color: 'lm',
                        fn: function () {
                        }
                      }
                    ]
                  });
                };

              })
              .catch(function (reason) {
                $scope.loading = false;
                $rootScope.hideLinearProgress('#reportsLoader');
                $rootScope.debugInfo(reason);
              });

            break;

          default:
            report.isShown = false;

            $timeout(function () {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#reportsLoader');

              ToastService.Big({
                title: 'Sorry',
                text: report.error,
                color: 'yellow',
                icon: 'chart-line',
                blocked: true
              }, 1000 * 5);
            }, 1200);
            break;
        }
      };

      $scope.toggleReport = function (report) {
        if (!report.isShown) {
          $scope.generateReport(report);
        }

        report.isShown = !report.isShown;
      };

      $scope.getReportsList();
    }]);
